var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormSelectTree',_vm._g(_vm._b({ref:"FormSelectTree",class:{'selectable':_vm.selectable}},'FormSelectTree',{ ..._vm.$attrs, alwaysOpen: true },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }